(function() { window.GUID_25c59539_db2d_4c8b_9b27_34884efc990e = { getGuid: function() { return "25c59539-db2d-4c8b-9b27-34884efc990e"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class SquareCreditCard extends Controls.CreditCard {
            loadScript() {
                let me = this;
                let url = CS.CommonData.Current.IsDebug() ? "https://sandbox.web.squarecdn.com/v1/square.js" : "https://web.squarecdn.com/v1/square.js";
                if (typeof (Square) != "undefined") {
                    loadSquare(me);
                }
                else {
                    $.getScript(url, () => __awaiter(this, void 0, void 0, function* () {
                        yield loadSquare(me);
                    }));
                }
                function loadSquare(me) {
                    return __awaiter(this, void 0, void 0, function* () {
                        const payments = Square.payments(me.publicKey, me.publicKey2);
                        me.card = yield payments.card();
                        yield me.card.attach('.new-card');
                    });
                }
            }
            OnDispose() {
                if (this.card) {
                    this.card.destroy();
                    this.card = null;
                }
                super.OnDispose();
            }
            onMakePaymentNewCard(useNewCardCallback) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        const result = yield this.card.tokenize();
                        if (result.status === 'OK') {
                            console.log(`Payment token is ${result.token}`);
                            if (this.$Control.triggerHandler("paymentRequest") == false) {
                            }
                        }
                        else {
                            // Handle tokenization errors
                            let errorMessage = `Tokenization failed with status: ${result.status}`;
                            if (result.errors) {
                                errorMessage += `\nErrors: ${result.errors.map(error => error.message).join('\n')}`;
                            }
                            console.error(errorMessage);
                        }
                        useNewCardCallback(result);
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            }
        }
        Controls.SquareCreditCard = SquareCreditCard;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=square-credit-card.js.map
